export default "__VITE_ASSET__DEz_PoWc__"